<ion-header class="ion-no-border ion-header-modal-mobile">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        id="back-modal-btn"
        data-cy="add-to-order-back-button"
        text=""
      ></ion-back-button>
    </ion-buttons>
    <ion-label data-cy="add-to-order-text">
      {{ 'i18n.orderPage.addToOrderModal.createNewOrder' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>
<ion-content [formGroup]="addToOrderModalForm" class="ion-content-modal-mobile">
  <div class="start-label-container">
    <span class="start-order-label" data-cy="start-order-label">
      {{ 'i18n.orderPage.addToOrderModal.startOrder' | translate }}
    </span>
  </div>
  <div class="start-order-common-container">
    <ion-item *ngIf="!data.disablePO" class="start-order-name">
      <ion-label
        id="start-order-label"
        position="stacked"
        data-cy="start-order-label"
      >
        {{ 'i18n.orderPage.addToOrderModal.poNumber' | translate }}
        <span *ngIf="data.isCustomerRequirePO" class="required-span">*</span>
      </ion-label>
      <ion-input
        aria-labelledby="start-order-label"
        formControlName="poNumber"
        placeholder="Enter here"
        id="po-input"
        [appRegexInputValidator]="poRegex"
        data-cy="po-input"
        maxlength="20"
      ></ion-input>
    </ion-item>
    <span
      *ngIf="data.isCustomerRequirePO"
      class="required-field-error-message"
      >{{
        'i18n.orderPage.addToOrderModal.requiredFieldMessage' | translate
      }}</span
    >
    <ng-container *ngIf="!data.isPoDisabledForVPTAndPunchOut">
      <ion-item *appShowSplit="[defaultPoFeatureFlag]" class="toggle-container">
        <ion-label class="toggle-label">{{
          'i18n.orderPage.saveDefaultPo' | translate
        }}</ion-label>
        <ion-toggle
          formControlName="saveDefaultPo"
          class="toggle-control"
          data-cy="save-default-po-mobile-modal"
        ></ion-toggle>
      </ion-item>
    </ng-container>
    <div id="deliver-date">
      <ion-label
        id="delivery-date"
        position="stacked"
        data-cy="start-order-label"
        class="start-order-name"
      >
        {{ 'i18n.orderPage.addToOrderModal.deliveryDate' | translate }}
      </ion-label>
      <div aria-labelledby="deliver-date" class="selected-date-label">
        <span
          >{{ 'i18n.orderPage.addToOrderModal.dateSelected' | translate }}:
        </span>
        {{
          addToOrderModalForm.controls.selectedDeliveryDate.value
            | date: 'M/d/yyyy' : 'GMT'
            | lowercase
        }}
      </div>
    </div>
    <div class="calendar-container">
      <!-- (ionChange)="ionChange(true)" -->
      <ion-datetime
        formControlName="selectedDeliveryDate"
        presentation="date"
        mode="ios"
        size="cover"
        data-cy="delivery-date-calendar"
        [min]="minDeliveryDate"
        [isDateEnabled]="isEligibleDay"
        [highlightedDates]="prontoDayStyle"
      >
      </ion-datetime>
      <div
        *ngIf="prontoDeliveryDays !== undefined"
        class="calendar-date-options"
      >
        <ion-item lines="none">
          <ion-icon
            name="ellipse"
            size="large"
            [style.color]="'#F3BA1633'"
          ></ion-icon>
          <p>{{ 'i18n.common.prontoDelivery' | translate }}</p>
        </ion-item>
        <ion-item lines="none">
          <ion-icon
            name="ellipse"
            size="large"
            [style.color]="'#DDE6D2'"
          ></ion-icon>
          <p>{{ 'i18n.common.standardDelivery' | translate }}</p>
        </ion-item>
      </div>
    </div>
  </div>
</ion-content>
<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        class="usf-outline-green-mobile-modal-button"
        data-cy="add-to-order-cancel-button"
        (click)="closeModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        class="usf-fill-green-mobile-modal-button"
        data-cy="add-to-order-next-button"
        (click)="onSubmit(data.currentTab, addToOrderModalForm)"
      >
        {{ 'i18n.orderPage.addToOrderModal.addProduct' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
